import { render, staticRenderFns } from "./LPText.vue?vue&type=template&id=4a05661b"
import script from "./LPText.vue?vue&type=script&lang=js"
export * from "./LPText.vue?vue&type=script&lang=js"
import style0 from "./LPText.vue?vue&type=style&index=0&id=4a05661b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports